import { tipsApi } from "../../api/tipsApi";

//**************** Actions that involve the store *****************//

//**************** Actions that don't involve the store *****************//
export async function fetchTips() {
    const tips = await tipsApi().getTips();
    return tips.data.result;
}